import React from "react";
import PropTypes from "prop-types";

import { ALL_LOCATION_TYPES_QUERY } from "../../graphql/Locations/LocationTypes.graphql";

import DataTable from "../DataTable";

import EditLocationTypeForm from "./EditLocationTypeForm";

const COLUMNS = [
  {
    Header: "Location Types",
    accessor: "LocType.CodeDescription"
  }
];

function LocationTypesTable({ id, setModalOpen }) {
  return (
    <DataTable
      columns={COLUMNS}
      dataQuery={ALL_LOCATION_TYPES_QUERY}
      initialSortBy={[{ id: "Description", desc: true }]}
      name="LocationType"
      where={{ LocationRecIdRef: parseInt(id) }}
      onRowClick={locType =>
        setModalOpen(
          true,
          <EditLocationTypeForm
            id={id}
            locType={locType}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
}

LocationTypesTable.propTypes = {
  id: PropTypes.number,
  setModalOpen: PropTypes.func
};
export default LocationTypesTable;
